import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from './theme.service';
import { Observable, filter, map } from 'rxjs';
import { AuthenticationService } from '@core/auth/authentication.service';
import { AppSharedDataService } from './app-shared-data.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import dayjs from 'dayjs';
import { VersionCheckService } from '@core/services/version-check.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { DOCUMENT } from '@angular/common';
import { datadogRum } from '@datadog/browser-rum';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  isLogged: boolean = true;
  isLoggedIn$: Observable<boolean>;
  isCollapsed: boolean = false;
  versaoApp: string = '';
  isProd = environment.production;

  constructor(
    private themeService: ThemeService,
    private appSharedDataService: AppSharedDataService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private versionCheckService: VersionCheckService,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.appSharedDataService?.minimizeMenu$.subscribe((res) => this.isCollapsed = res);
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
    this.verifyRoute();
    this.carregarVersao();
    this.authenticationService.currentUser
      .pipe(filter((u: any) => !!u?.id))
      .subscribe(u => this.dataDogUserLogin(u));


  }

  
  ngOnInit(): void {
 this.versionCheckService.verificarVersao();
    if (!this.isProd) {
      this.document.body.classList.add('has-nonprod-banner');
    }  }

  ngOnDestroy(): void {
    this.document.body.classList.remove('has-nonprod-banner');
  }




  verifyRoute() {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => {
        return { event, route: this.rootRoute(this.route) };
      })
    ).subscribe((data: { event: NavigationEnd, route: ActivatedRoute }) => {
      const expires_in = dayjs(this.authenticationService?.currentUserValue?.expires_in).toDate();
      const dataAtual = dayjs().toDate();
      if (expires_in < dataAtual) {
        this.authenticationService.logout();
        this.router.navigateByUrl('/login');
      }
    });
  }



  private rootRoute(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  carregarVersao(): void {
    const versaoSalva = localStorage.getItem('app_version');

    if (versaoSalva) {
      this.versaoApp = versaoSalva;
    } else {
      this.http.get<{ version: string }>('/assets/version.json', { headers: { 'Cache-Control': 'no-cache' } })
        .subscribe({
          next: (data) => {
            this.versaoApp = `*${data.version}`;
            localStorage.setItem('app_version', data.version);
          },
          error: () => this.versaoApp = 'desconhecida'
        });
    }
  }

  dataDogUserLogin(user: any) {
    if (environment.production) {
      datadogRum.setUser({
        id: user.id.toString(),
        username: user.login,
        name: user.nome,
        env: environment.datadog,
        route: this.router.url,
        url_path_group: this.router.url
      });
      datadogRum.startView({ name: this.router.url });
    }
  }
}  
